import { Injectable } from '@angular/core';
import { Theme } from 'src/app/configs/theme.config';
import { DashboardModes, Desktop } from '../../api/models';
import { Colors } from '../../api/models/colors';
import { StatsWidgetNumber } from '../../enums/stats-widget-number.enum';
import { AppStateService } from '../../services/app-state.service';
import { CancelBtnType } from '../../types/app-cancel-btn.type';

@Injectable({
  providedIn: 'root',
})
export class ThemeColorService {
  appTheme: Desktop;
  cancelBtnType: CancelBtnType = Theme.cancelBtnType;
  primaryColor: Colors;
  secondaryColor: Colors;
  backgroundImagePath: string;
  dashboardMode: DashboardModes;

  constructor() {}

  getTextColor(): string {
    let className: string = '';
    this.getCurrentClientData();

    if (this.appTheme != Desktop.Default) {
      switch (this.appTheme) {
        case Desktop.ErshadDesktop:
          className = 'text-ministry';
          break;
        default:
          className = 'text-primary';
          break;
      }
      return className;
    }

    className = this.getPrimaryColorStyle('text-');
    return className;
  }

  getBtnColor(): string {
    let className: string = '';
    this.getCurrentClientData();

    if (this.appTheme != Desktop.Default) {
      switch (this.appTheme) {
        case Desktop.ErshadDesktop:
          className = 'btn-ministry';
          break;
        default:
          className = 'btn-primary';
          break;
      }
      return className;
    }
    className = this.getPrimaryColorStyle('btn-');
    return className;
  }

  getBtnInfoColor(): string {
    let className: string = '';
    this.getCurrentClientData();

    if (this.appTheme != Desktop.Default) {
      switch (this.appTheme) {
        case Desktop.ErshadDesktop:
          className += 'btn-yellow';
          break;
        default:
          className += 'btn-info';
          break;
      }
      return className;
    }
    className = this.getSecondaryColorStyle('btn-');
    return className;
  }

  getBtnLightColor(): string {
    let className: string = '';
    this.getCurrentClientData();

    if (this.appTheme != Desktop.Default) {
      switch (this.appTheme) {
        case Desktop.ErshadDesktop:
          className = 'btn-light-ministry';
          break;
        default:
          className = 'btn-light-primary';
          break;
      }
      return className;
    }
    className = this.getPrimaryColorStyle('btn-light-');
    return className;
  }

  getBtnLightInfoColor(): string {
    let className: string = '';
    this.getCurrentClientData();

    if (this.appTheme != Desktop.Default) {
      switch (this.appTheme) {
        case Desktop.ErshadDesktop:
          className += 'btn-light-yellow';
          break;
        default:
          className += 'btn-light-info';
          break;
      }
      return className;
    }
    className = this.getSecondaryColorStyle('btn-light-');
    return className;
  }

  getCancelBtnColor(): string {
    let className: string = '';
    this.getCurrentClientData();

    switch (this.cancelBtnType) {
      case CancelBtnType.Red:
        className = 'btn-danger';
        break;
      case CancelBtnType.Slate:
        className = 'btn-slate';
        break;
      default:
        className = 'btn-danger';
        break;
    }
    return className;
  }

  getBgImage(): string {
    let className: string = '';
    this.getCurrentClientData();

    switch (this.appTheme) {
      case Desktop.ErshadDesktop:
        className =
          "tw-bg-[url('/assets/media/logos/ministry-loading-bg.jpg')] tw-relative";
        break;
      case Desktop.ElectionDesktop:
        className =
          "tw-bg-[url('/assets/media/logos/election-loading-bg.jpg')] tw-relative";
        break;
      case Desktop.Default:
        className = "tw-bg-[url('/assets/media/logos/loading-bg.jpg')]";
        break;
      default:
        className = "tw-bg-[url('/assets/media/logos/loading-bg.jpg')]";
        break;
    }

    return className;
  }

  getStatsWidgetBgColor(statsWidgetNumber: number): string {
    let className: string = '';
    this.getCurrentClientData();

    if (this.dashboardMode == DashboardModes.MultipleColors) {
      switch (statsWidgetNumber) {
        case StatsWidgetNumber.FirstStateWidget:
          if (this.appTheme == Desktop.ErshadDesktop) {
            className = 'bg-gradient-ministry';
            return className;
          }
          className = 'bg-gradient-danger';
          break;
        case StatsWidgetNumber.SecondStateWidget:
          if (this.appTheme == Desktop.ErshadDesktop) {
            className = 'bg-gradient-yellow';
            return className;
          }
          className = 'bg-gradient-info';
          break;
        case StatsWidgetNumber.ThirdStateWidget:
          if (this.appTheme == Desktop.ErshadDesktop) {
            className = 'bg-gradient-ministry';
            return className;
          }
          className = 'bg-gradient-green';
          break;
        case StatsWidgetNumber.ForthStateWidget:
          className = 'bg-gradient-yellow';
          break;
      }
      return className;
    }

    switch (statsWidgetNumber) {
      case StatsWidgetNumber.FirstStateWidget:
        className = this.getBgGradientPrimaryColor();
        break;

      case StatsWidgetNumber.SecondStateWidget:
        className = this.getBgGradientSecondaryColor();
        break;
      case StatsWidgetNumber.ThirdStateWidget:
        className = this.getBgGradientPrimaryColor();
        break;
      case StatsWidgetNumber.ForthStateWidget:
        className = this.getBgGradientSecondaryColor();
        break;
    }
    return className;
  }

  getBgGradientPrimaryColor(): string {
    let className: string = '';
    this.getCurrentClientData();

    if (this.appTheme != Desktop.Default) {
      switch (this.appTheme) {
        case Desktop.ErshadDesktop:
          className = 'bg-gradient-ministry';
          break;
        default:
          className = 'bg-gradient-primary';
          break;
      }
      return className;
    }

    className = this.getPrimaryColorStyle('bg-gradient-');
    return className;
  }

  getBgGradientSecondaryColor(): string {
    let className: string = '';
    this.getCurrentClientData();

    if (this.appTheme != Desktop.Default) {
      switch (this.appTheme) {
        case Desktop.ErshadDesktop:
          className = 'bg-gradient-yellow';
          break;
        default:
          className = 'bg-gradient-info';
          break;
      }
      return className;
    }

    className = this.getSecondaryColorStyle('bg-gradient-');
    return className;
  }

  getBtnGradientColor(): string {
    let className: string = 'btn-gradient ';
    this.getCurrentClientData();

    if (this.appTheme != Desktop.Default) {
      switch (this.appTheme) {
        case Desktop.ErshadDesktop:
          className += 'btn-gradient-ministry';
          break;
        default:
          className += 'btn-gradient-primary';
          break;
      }
      return className;
    }

    className += this.getPrimaryColorStyle('btn-gradient-');
    return className;
  }

  getRingBtnGradientColor(): string {
    let className: string = 'btn-gradient ';
    this.getCurrentClientData();

    if (this.appTheme != Desktop.Default) {
      switch (this.appTheme) {
        case Desktop.ErshadDesktop:
          className +=
            'btn-gradient-ministry hover:tw-ring-[var(--color-ministry)]';
          break;
        default:
          className +=
            'btn-gradient-primary hover:tw-ring-[var(--color-primary)]';
          break;
      }
      return className;
    }
    className +=
      this.getPrimaryColorStyle('btn-gradient-') +
      ' ' +
      this.getPrimaryColorStyle('hover:tw-ring-[var(--color-') +
      ')]';
    return className;
  }

  getLoadingBarColor(): string {
    let className: string = '';
    this.getCurrentClientData();

    if (this.appTheme != Desktop.Default) {
      switch (this.appTheme) {
        case Desktop.ErshadDesktop:
          className = 'loading-bar-ministry';
          break;
        default:
          className = 'loading-bar-primary';
          break;
      }
      return className;
    }

    className = this.getPrimaryColorStyle('loading-bar-');
    return className;
  }

  getTimerLoadingColor(): string {
    let className: string = '';
    this.getCurrentClientData();

    if (this.appTheme != Desktop.Default) {
      switch (this.appTheme) {
        case Desktop.ErshadDesktop:
          className = 'tw-bg-[var(--color-ministry)]';
          break;
        default:
          className = 'tw-bg-[var(--color-primary)]';
          break;
      }
      return className;
    }
    className = this.getPrimaryColorStyle('tw-bg-[var(--color-') + ')]';
    return className;
  }

  // This method creates a class on the Primary Color
  getPrimaryColorStyle(type: string, customColor?: Colors) {
    let className: string = '';

    switch (customColor ? customColor : this.primaryColor) {
      case Colors.Blue:
        className = type + 'blue';
        break;
      case Colors.Gray:
        className = type + 'slate';
        break;
      case Colors.Orange:
        className = type + 'orange';
        break;
      case Colors.Pink:
        className = type + 'pink';
        break;
      case Colors.Purple:
        className = type + 'info';
        break;
      case Colors.Red:
        className = type + 'danger';
        break;
      case Colors.Yellow:
        className = type + 'yellow';
        break;
      case Colors.Default:
        className = type + 'primary';
        break;
      default:
        className = type + 'primary';
        break;
    }
    return className;
  }

  // This method creates a class on the Secondary Color
  getSecondaryColorStyle(type: string) {
    let className: string = '';

    switch (this.secondaryColor) {
      case Colors.Blue:
        className = type + 'blue';
        break;
      case Colors.Gray:
        className = type + 'slate';
        break;
      case Colors.Orange:
        className = type + 'orange';
        break;
      case Colors.Pink:
        className = type + 'pink';
        break;
      case Colors.Purple:
        className = type + 'info';
        break;
      case Colors.Red:
        className = type + 'danger';
        break;
      case Colors.Yellow:
        className = type + 'yellow';
        break;
      case Colors.Default:
        className = type + 'info';
        break;
      default:
        className = type + 'primary';
        break;
    }
    return className;
  }

  getCurrentClientData() {
    this.appTheme = AppStateService.appTheme;
    this.secondaryColor = AppStateService.secondaryColor;
    this.primaryColor = AppStateService.primaryColor;
    this.backgroundImagePath = AppStateService.backgroundImagePath;
    this.dashboardMode = AppStateService.dashboardMode;
  }
}
